import { createContext } from 'react';
import { IUser } from '../models/interfaces/user.interface';

export const GlobalAppContext = createContext({
  user: { id: 0, countryId: 0, roleId: 0, name: '', email: '', dateOfBirth: '', isActive: false, isBackOffice: false },
  setUser: (user: IUser) => {},
  token: '',
  setToken: (token: string) => {},
  isUserSignedIn: false,
  setIsUserSignedIn: (isUserSignedIn: boolean) => {},
  monthIndex: 0,
  setMonthIndex: (index: number) => {},
  showEventModal: false,
  setShowEventModal: (showEventModal: boolean) => {}
});

export default GlobalAppContext;
